/* Intent-based page prefetching. Fetches documents without running their scripts. */
(() => {
  'use strict';
  const appPrefetchPresent = () => Array.from(document.scripts).some(script => /\/smartseo\/instantpage\.js(?:[?#]|$)/i.test(script.src));
  if (appPrefetchPresent()) return;
  const connection = navigator.connection;
  if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '') || navigator.onLine === false) return;
  const warmed = new Set();
  const maxPages = 6;
  const supportsRules = typeof HTMLScriptElement.supports === 'function' && HTMLScriptElement.supports('speculationrules');
  const supportsPrefetch = document.createElement('link').relList?.supports?.('prefetch');
  if (!supportsRules && !supportsPrefetch) return;
  let hoverTimer;
  function eligible(target) {
    const anchor = target instanceof Element ? target.closest('a[href]') : null;
    if (!anchor || anchor.download || anchor.target && anchor.target !== '_self' || anchor.hasAttribute('data-no-prefetch') || /nofollow/i.test(anchor.rel)) return null;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || url.search || url.hash) return null;
    const path = url.pathname.replace(/\/$/, '') || '/';
    if (path === (location.pathname.replace(/\/$/, '') || '/') || /^\/(?:cart|checkout|checkouts|account|orders|apps|a|tools|admin|challenge|password|search|discount|localization|policies)(?:\/|$)/i.test(path)) return null;
    if (/\.(?:json|js|css|xml|csv|pdf|zip|jpe?g|png|webp|gif|svg|mp4)$/i.test(path)) return null;
    if (path !== '/' && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products|collections|pages|blogs)(?:\/|$)/i.test(path)) return null;
    if (/\/(?:wishlist|swym-wishlist|swym-share-wishlist|wish-list|track-my-order|ccpa-opt-out|search-results|quick-buy)(?:\/|$)/i.test(path)) return null;
    return url.href;
  }
  function warm(target) {
    if (appPrefetchPresent() || document.visibilityState !== 'visible' || navigator.onLine === false || connection?.saveData || warmed.size >= maxPages) return;
    const href = eligible(target);
    if (!href || warmed.has(href)) return;
    warmed.add(href);
    if (supportsRules) {
      const script = document.createElement('script');
      script.type = 'speculationrules';
      script.dataset.mcsPrefetch = '';
      script.textContent = JSON.stringify({prefetch: [{source: 'list', urls: [href]}]});
      document.head.append(script);
    } else {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'document';
      link.href = href;
      link.dataset.mcsPrefetch = '';
      document.head.append(link);
    }
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    clearTimeout(hoverTimer);
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (anchor) hoverTimer = setTimeout(() => warm(anchor), 65);
  }, {passive: true});
  document.addEventListener('pointerout', () => clearTimeout(hoverTimer), {passive: true});
  document.addEventListener('pointerdown', event => {
    if (event.isPrimary && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) warm(event.target);
  }, {passive: true});
  document.addEventListener('focusin', event => warm(event.target), {passive: true});
})();
